var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(
      _vm.$route.path == '/Main' ||
      _vm.$route.path == '/MainMenu' ||
      _vm.$route.path == '/ManagePreRegister' ||
      _vm.$route.path == '/ManageUser' ||
      _vm.$route.path == '/ManageRole' ||
      _vm.$route.path == '/MyQR' ||
      _vm.$route.path == '/CallLift' ||
      _vm.$route.path == '/ParkingInformation' ||
      _vm.$route.path == '/PreRegister' ||
      _vm.$route.path == '/Redemption' ||
      _vm.$route.path == '/TerminalStamp' ||
      _vm.$route.path == '/ManageQuotaRate'
    )?_c('NavBar'):_vm._e(),_c('v-content',[_c('div',[_c('router-view')],1)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }